var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61035 23.5326V9.64778C3.61035 6.36383 6.27496 3.69922 9.55891 3.69922H12.9581",
    stroke: "#F9411F",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4436 7.24219V19.1393C23.4436 21.5591 21.4703 23.5323 19.0506 23.5323H9.02588",
    stroke: "#F9411F",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 9.28906L19.2092 19.8179",
    stroke: "#F9411F",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.238 9.28906L8.66602 19.8179",
    stroke: "#F9411F",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDarkRed);
export default __webpack_public_path__ + "static/media/DELETE __ DARK Red.9923e2c27cc02ce4376f789338301f2d.svg";
export { ForwardRef as ReactComponent };